export default __webpack_public_path__ + "static/media/kaiko3.661a52ec.png";